/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listQrOrderingData} from '../api'

export const useMutationListQrOrderingData = createReactQueryMutationHook('listQrOrderingData', listQrOrderingData)
